import React from 'react';
import WelcomePopup from '../components/home/WelcomePopup';
import HeroSection from '../components/home/HeroSection';
import FeaturedProperties from '../components/home/FeaturedProperties';
import AboutAgency from '../components/home/AboutAgency'; // <-- 1. Import it
import NewProperties from '../components/home/NewProperties';
import DocumentsRequired from '../components/home/DocumentsRequired';

export default function Home() {
  return (
    <div className="overflow-x-hidden w-full">
      <WelcomePopup />
      <HeroSection />
      <AboutAgency />
      <FeaturedProperties />
      <NewProperties />
      <DocumentsRequired />
    </div>
  );
}